/**
 * @generated SignedSource<<d0633ff17ee9fdcf7229911e0d61094d>>
 * @relayHash 888ef48e230efbbd8e4c9a23055966fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ca4788a316f28c63b495147583dcf07a2123bac9d07b331d3be91655b5955c2

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HomeRecentsListQuery$variables = {
  actors?: ReadonlyArray<string> | null;
  collabContextId?: string | null;
  eventTypes?: ReadonlyArray<string> | null;
  first?: number | null;
  isOtherUser: boolean;
  isViewed: boolean;
  isWorkedOn: boolean;
  rootContainerIds?: ReadonlyArray<string> | null;
};
export type HomeRecentsListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomeRecentsList">;
};
export type HomeRecentsListQuery = {
  response: HomeRecentsListQuery$data;
  variables: HomeRecentsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actors"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collabContextId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTypes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isOtherUser"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isViewed"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isWorkedOn"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rootContainerIds"
},
v8 = {
  "kind": "Variable",
  "name": "actors",
  "variableName": "actors"
},
v9 = {
  "kind": "Variable",
  "name": "collabContextId",
  "variableName": "collabContextId"
},
v10 = {
  "kind": "Variable",
  "name": "eventTypes",
  "variableName": "eventTypes"
},
v11 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v12 = {
  "kind": "Variable",
  "name": "rootContainerIds",
  "variableName": "rootContainerIds"
},
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "kind": "ScalarField",
  "name": "picture"
},
v18 = {
  "kind": "ScalarField",
  "name": "label"
},
v19 = {
  "concreteType": "AssetsLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "web"
    }
  ]
},
v20 = [
  {
    "kind": "ScalarField",
    "name": "url48"
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v22 = {
  "concreteType": "AssetsSchema",
  "kind": "LinkedField",
  "name": "schema",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v13/*: any*/)
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "displayTypename"
},
v24 = {
  "alias": "filterName",
  "kind": "ScalarField",
  "name": "name"
},
v25 = {
  "kind": "ScalarField",
  "name": "url"
},
v26 = {
  "alias": "filterNameRequired",
  "kind": "ScalarField",
  "name": "name"
},
v27 = {
  "kind": "ScalarField",
  "name": "title"
},
v28 = {
  "kind": "ScalarField",
  "name": "webUi"
},
v29 = {
  "kind": "ScalarField",
  "name": "base"
},
v30 = [
  (v28/*: any*/),
  (v29/*: any*/)
],
v31 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    {
      "concreteType": "ConfluenceSpaceLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v30/*: any*/)
    },
    (v13/*: any*/)
  ]
},
v32 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v33 = {
  "kind": "ScalarField",
  "name": "value"
},
v34 = [
  (v33/*: any*/)
],
v35 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiPublished",
      "plural": false,
      "selections": (v34/*: any*/)
    }
  ]
},
v36 = {
  "alias": "filterName",
  "kind": "ScalarField",
  "name": "title"
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v27/*: any*/),
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v30/*: any*/)
    },
    (v31/*: any*/),
    (v32/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/)
  ],
  "type": "ConfluenceBlogPost"
},
v38 = {
  "concreteType": "ConfluenceContentVersion",
  "kind": "LinkedField",
  "name": "latestVersion",
  "plural": false,
  "selections": [
    (v32/*: any*/)
  ]
},
v39 = [
  (v29/*: any*/),
  (v28/*: any*/)
],
v40 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v27/*: any*/),
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v30/*: any*/)
    },
    (v31/*: any*/),
    (v32/*: any*/),
    (v35/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subtype"
    },
    (v36/*: any*/)
  ],
  "type": "ConfluencePage"
},
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v27/*: any*/),
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v30/*: any*/)
    },
    (v38/*: any*/),
    (v31/*: any*/),
    (v36/*: any*/)
  ],
  "type": "ConfluenceWhiteboard"
},
v42 = {
  "kind": "ScalarField",
  "name": "connectorType"
},
v43 = {
  "kind": "ScalarField",
  "name": "thirdPartyId"
},
v44 = {
  "kind": "ScalarField",
  "name": "category"
},
v45 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v46 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v47 = [
  (v13/*: any*/)
],
v48 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": [
      (v16/*: any*/),
      (v17/*: any*/),
      (v13/*: any*/)
    ]
  },
  {
    "args": (v45/*: any*/),
    "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
    "kind": "LinkedField",
    "name": "linkedUsers",
    "plural": false,
    "selections": [
      {
        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v46/*: any*/),
                  (v13/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              },
              {
                "kind": "InlineFragment",
                "selections": (v47/*: any*/),
                "type": "AppUser"
              },
              {
                "kind": "InlineFragment",
                "selections": (v47/*: any*/),
                "type": "CustomerUser"
              }
            ]
          },
          (v13/*: any*/)
        ]
      }
    ],
    "storageKey": "linkedUsers(first:1)"
  }
],
v49 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v51 = {
  "concreteType": "ExternalProvider",
  "kind": "LinkedField",
  "name": "provider",
  "plural": false,
  "selections": [
    (v50/*: any*/)
  ]
},
v52 = {
  "alias": "filterName",
  "kind": "ScalarField",
  "name": "displayName"
},
v53 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v16/*: any*/),
    (v46/*: any*/),
    (v13/*: any*/)
  ]
},
v54 = {
  "kind": "ScalarField",
  "name": "summary"
},
v55 = {
  "kind": "ScalarField",
  "name": "key"
},
v56 = {
  "concreteType": "JiraDateTimePickerField",
  "kind": "LinkedField",
  "name": "updatedField",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "dateTime"
    },
    (v13/*: any*/)
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "dueDate"
},
v58 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v16/*: any*/),
        {
          "concreteType": "JiraStatusCategory",
          "kind": "LinkedField",
          "name": "statusCategory",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "mercuryName"
            },
            (v13/*: any*/)
          ]
        },
        (v13/*: any*/)
      ]
    },
    (v13/*: any*/)
  ]
},
v59 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v60 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v16/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "small"
            }
          ]
        },
        (v13/*: any*/)
      ]
    },
    (v13/*: any*/)
  ]
},
v61 = {
  "concreteType": "JiraProjectField",
  "kind": "LinkedField",
  "name": "projectField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v16/*: any*/),
        (v59/*: any*/),
        (v13/*: any*/)
      ]
    },
    (v13/*: any*/)
  ]
},
v62 = {
  "alias": "filterName",
  "kind": "ScalarField",
  "name": "summary"
},
v63 = {
  "alias": "goalCreationDate",
  "kind": "ScalarField",
  "name": "creationDate"
},
v64 = [
  {
    "kind": "ScalarField",
    "name": "creationDate"
  },
  {
    "kind": "ScalarField",
    "name": "editDate"
  },
  (v13/*: any*/)
],
v65 = {
  "alias": "goalUpdates",
  "args": (v45/*: any*/),
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareGoalUpdateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareGoalUpdate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v64/*: any*/)
        }
      ]
    }
  ],
  "storageKey": "updates(first:1)"
},
v66 = {
  "alias": "goalStatus",
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    {
      "kind": "ScalarField",
      "name": "score"
    }
  ]
},
v67 = {
  "kind": "ScalarField",
  "name": "iconData"
},
v68 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v16/*: any*/),
    (v46/*: any*/),
    (v15/*: any*/),
    (v13/*: any*/)
  ]
},
v69 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v13/*: any*/)
],
v70 = {
  "alias": "goalOwner",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v69/*: any*/)
},
v71 = {
  "alias": "projectCreationDate",
  "kind": "ScalarField",
  "name": "creationDate"
},
v72 = {
  "alias": "projectState",
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v34/*: any*/)
},
v73 = {
  "alias": "projectUpdates",
  "args": (v45/*: any*/),
  "concreteType": "TownsquareProjectUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareProjectUpdateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareProjectUpdate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v64/*: any*/)
        }
      ]
    }
  ],
  "storageKey": "updates(first:1)"
},
v74 = {
  "alias": "projectOwner",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v69/*: any*/)
},
v75 = {
  "kind": "InlineFragment",
  "selections": (v47/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v76 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v39/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v14/*: any*/),
      {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isConfluenceCommentContainer"
      },
      (v37/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v75/*: any*/)
    ]
  }
],
v77 = [
  (v59/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      (v14/*: any*/),
      (v54/*: any*/),
      (v55/*: any*/),
      (v56/*: any*/),
      (v57/*: any*/),
      (v58/*: any*/),
      (v13/*: any*/),
      (v59/*: any*/),
      (v60/*: any*/),
      (v61/*: any*/),
      (v62/*: any*/)
    ]
  }
],
v78 = [
  {
    "concreteType": "ActivityItemEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "ActivityNode",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "concreteType": "ActivityEvent",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "timestamp"
              },
              (v13/*: any*/)
            ]
          },
          {
            "concreteType": "ActivityObject",
            "kind": "LinkedField",
            "name": "object",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "ScalarField",
                "name": "rootContainerId"
              },
              {
                "kind": "ScalarField",
                "name": "product"
              },
              {
                "concreteType": "ActivityContributor",
                "kind": "LinkedField",
                "name": "contributors",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "concreteType": "AssetsAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": (v20/*: any*/)
                      },
                      {
                        "concreteType": "AssetsObjectType",
                        "kind": "LinkedField",
                        "name": "objectType",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      (v23/*: any*/),
                      {
                        "alias": "filterName",
                        "kind": "ScalarField",
                        "name": "label"
                      }
                    ],
                    "type": "AssetsObject"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      {
                        "alias": "assetsObjectTypeName",
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v19/*: any*/),
                      {
                        "concreteType": "AssetsIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": (v20/*: any*/)
                      },
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ],
                    "type": "AssetsObjectType"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      {
                        "alias": "assetsSchemaName",
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v19/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ],
                    "type": "AssetsSchema"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v16/*: any*/),
                      (v25/*: any*/),
                      {
                        "concreteType": "CompassComponentTypeObject",
                        "kind": "LinkedField",
                        "name": "typeMetadata",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                          },
                          (v16/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      (v26/*: any*/)
                    ],
                    "type": "CompassComponent"
                  },
                  (v37/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v27/*: any*/),
                      {
                        "concreteType": "ConfluenceDatabaseLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": (v30/*: any*/)
                      },
                      (v38/*: any*/),
                      (v31/*: any*/),
                      (v36/*: any*/)
                    ],
                    "type": "ConfluenceDatabase"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v27/*: any*/),
                      {
                        "concreteType": "ConfluenceEmbedLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": (v39/*: any*/)
                      },
                      {
                        "concreteType": "ConfluenceSpace",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      (v36/*: any*/)
                    ],
                    "type": "ConfluenceEmbed"
                  },
                  (v40/*: any*/),
                  (v41/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v21/*: any*/),
                      (v25/*: any*/),
                      {
                        "concreteType": "ExternalDocumentType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": [
                          (v44/*: any*/)
                        ]
                      },
                      (v49/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/)
                    ],
                    "type": "ExternalDocument"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v21/*: any*/),
                      (v25/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastUpdate"
                      },
                      {
                        "concreteType": "ExternalUser",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": (v48/*: any*/)
                      },
                      {
                        "concreteType": "ExternalReviewer",
                        "kind": "LinkedField",
                        "name": "reviewers",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "approvalStatus"
                          },
                          {
                            "concreteType": "ExternalUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v48/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "ExternalProvider",
                        "kind": "LinkedField",
                        "name": "provider",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v50/*: any*/)
                        ]
                      },
                      (v52/*: any*/)
                    ],
                    "type": "ExternalPullRequest"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v21/*: any*/),
                      (v25/*: any*/),
                      (v49/*: any*/),
                      (v44/*: any*/),
                      {
                        "alias": "externalLinkStatus",
                        "concreteType": "ExternalRemoteLinkStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appearance"
                          }
                        ]
                      },
                      (v51/*: any*/),
                      (v52/*: any*/)
                    ],
                    "type": "ExternalRemoteLink"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v21/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": "workItemStatus",
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      (v51/*: any*/),
                      (v52/*: any*/)
                    ],
                    "type": "ExternalWorkItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v16/*: any*/),
                      (v25/*: any*/),
                      {
                        "concreteType": "MercuryFocusArea",
                        "kind": "LinkedField",
                        "name": "parent",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v16/*: any*/),
                          (v25/*: any*/)
                        ]
                      },
                      {
                        "alias": "focusAreaIcon",
                        "concreteType": "MercuryFocusAreaIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "createdDate"
                      },
                      (v53/*: any*/),
                      (v26/*: any*/)
                    ],
                    "type": "MercuryFocusArea"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v16/*: any*/),
                      (v25/*: any*/),
                      (v18/*: any*/),
                      (v26/*: any*/)
                    ],
                    "type": "MercuryPortfolio"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v54/*: any*/),
                      (v55/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v13/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/)
                    ],
                    "type": "JiraIssue"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": "loomVideoUrl",
                        "kind": "ScalarField",
                        "name": "url"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updatedAt"
                      },
                      (v53/*: any*/),
                      (v26/*: any*/)
                    ],
                    "type": "LoomVideo"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      {
                        "concreteType": "RadarWorker",
                        "kind": "LinkedField",
                        "name": "worker",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "preferredName"
                          },
                          (v13/*: any*/),
                          {
                            "alias": "filterName",
                            "kind": "ScalarField",
                            "name": "preferredName"
                          }
                        ]
                      },
                      (v25/*: any*/)
                    ],
                    "type": "RadarPosition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "viewName"
                      },
                      (v25/*: any*/),
                      {
                        "alias": "filterNameRequired",
                        "kind": "ScalarField",
                        "name": "viewName"
                      }
                    ],
                    "type": "RadarView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v16/*: any*/),
                      (v25/*: any*/),
                      (v63/*: any*/),
                      (v65/*: any*/),
                      (v66/*: any*/),
                      (v67/*: any*/),
                      (v68/*: any*/),
                      (v26/*: any*/),
                      (v70/*: any*/)
                    ],
                    "type": "TownsquareGoal"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v16/*: any*/),
                      (v25/*: any*/),
                      (v71/*: any*/),
                      (v72/*: any*/),
                      (v73/*: any*/),
                      (v67/*: any*/),
                      (v68/*: any*/),
                      (v26/*: any*/),
                      (v74/*: any*/)
                    ],
                    "type": "TownsquareProject"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "container",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isTownsquareCommentContainer"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v16/*: any*/),
                              (v25/*: any*/),
                              (v63/*: any*/),
                              (v65/*: any*/),
                              (v66/*: any*/),
                              (v67/*: any*/),
                              (v68/*: any*/),
                              (v70/*: any*/),
                              (v26/*: any*/)
                            ],
                            "type": "TownsquareGoal"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v16/*: any*/),
                              (v25/*: any*/),
                              (v71/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v67/*: any*/),
                              (v68/*: any*/),
                              (v74/*: any*/),
                              (v26/*: any*/)
                            ],
                            "type": "TownsquareProject"
                          },
                          (v75/*: any*/)
                        ]
                      }
                    ],
                    "type": "TownsquareComment"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v76/*: any*/),
                    "type": "ConfluenceInlineComment"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v76/*: any*/),
                    "type": "ConfluenceFooterComment"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v77/*: any*/),
                    "type": "JiraPlatformComment"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v77/*: any*/),
                    "type": "JiraServiceManagementComment"
                  },
                  (v75/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v47/*: any*/),
                    "type": "DevOpsPullRequestDetails"
                  }
                ]
              }
            ]
          },
          (v13/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeRecentsListQuery",
    "selections": [
      {
        "args": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "Variable",
            "name": "isOtherUser",
            "variableName": "isOtherUser"
          },
          {
            "kind": "Variable",
            "name": "isViewed",
            "variableName": "isViewed"
          },
          {
            "kind": "Variable",
            "name": "isWorkedOn",
            "variableName": "isWorkedOn"
          },
          (v12/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "HomeRecentsList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeRecentsListQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "condition": "isWorkedOn",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": [
                      {
                        "fields": [
                          (v9/*: any*/),
                          (v12/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      },
                      (v11/*: any*/)
                    ],
                    "concreteType": "ActivityConnection",
                    "kind": "LinkedField",
                    "name": "workedOn",
                    "plural": false,
                    "selections": (v78/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "condition": "isViewed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "fields": [
                      (v8/*: any*/),
                      {
                        "fields": [
                          (v10/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "arguments"
                      },
                      (v9/*: any*/),
                      (v12/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v11/*: any*/)
                ],
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": (v78/*: any*/)
              }
            ]
          },
          {
            "condition": "isOtherUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "fields": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v12/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v11/*: any*/)
                ],
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "workedOn",
                "plural": false,
                "selections": (v78/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6ca4788a316f28c63b495147583dcf07a2123bac9d07b331d3be91655b5955c2",
    "metadata": {},
    "name": "HomeRecentsListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b743fa0cf1f61b441190c0532e2c6f26";

export default node;
